
const PublicConsultationsIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <rect
            width={15}
            height={15}
            x={17.5}
            y={17.782}
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            rx={5}
            transform="rotate(180 17.5 17.782)"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M6.667 13.615v-2.5M10 13.615V6.95M13.333 13.615V9.45"
        />
    </svg>
)

export default PublicConsultationsIcon
